export default __webpack_public_path__ + "static/media/3.27008886.png";